module.exports = __webpack_public_path__ + "img/gsnd2760_1.aa5bc49b.svg";